import { AbstractTarget } from './AbstractTarget.js';

/**
 * 予測ターゲットクラス
 * 将来アクティブになる予定の的を表現
 */
export class PredictiveTarget extends AbstractTarget {
    /**
     * 予測ターゲットのコンストラクタ
     * @param {Phaser.Scene} scene - シーンオブジェクト
     * @param {number} x - X座標
     * @param {number} y - Y座標
     */
    constructor(scene, x, y, targetType = null, order = 0) {
        super(scene, x, y, targetType, order);
        
        // 次の順番（デフォルトは0）
        this.nextOrder = 0;
        
        // ターゲットの種類に応じたサイトテクスチャを設定
        const siteTextureName = this.getSiteTextureNameByType();
        this.sprite.setTexture(siteTextureName);
        
        // 物理ボディを衝突しないように設定
        this.scene.matter.body.set(this.body, {
            isSensor: true,  // センサーのままにする
            collisionFilter: { 
                group: 0,
                category: 0x0004,
                mask: 0x0000  // どのカテゴリとも衝突しない
            }
        });
        
        // デフォルトでは不透明に近い設定
        this.container.setAlpha(0.9);
        
        // アニメーションを管理するためのプロパティ
        this.alphaTween = null;
    }
    
    /**
     * サイトテクスチャ名を取得
     * @returns {string} テクスチャ名
     */
    getSiteTextureNameByType() {
        // 常に黄色のサイトテクスチャを返す
        return 'target_site_yellow';
    }
    
    /**
     * 次の順番を設定
     * @param {number} order - 順番（1: 次, 2: その次, ...）
     */
    setNextOrder(order) {
        this.nextOrder = order;
        
        // 既存のtweenがあれば停止
        if (this.alphaTween) {
            this.alphaTween.stop();
        }

        if (order === 1) {
            // 次のターゲット: 完全表示
            this.container.setAlpha(1.0);
        } else if (order === 2) {
            this.container.setAlpha(0.6);
        } else {
            // それ以降: 30%表示
            this.container.setAlpha(0.3);
        }
    }
    
    /**
     * 次の順番を取得
     * @returns {number} 次の順番
     */
    getNextOrder() {
        return this.nextOrder;
    }
    
    /**
     * リソースのクリーンアップ
     */
    destroy() {
        if (this.alphaTween) {
            this.alphaTween.stop();
        }
        super.destroy();
    }

    /**
     * 順番を取得
     * @returns {number} ターゲットの順番
     */
    getOrder() {
        return this.order;
    }
}
